/* eslint-disable no-underscore-dangle */
import CustomListView from 'src/components/customTable/CustomListView';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Grid, Button, Container, Tab, Tabs } from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import useSettings from 'src/hooks/useSettings';
import setTitle from 'src/utils/setTitle';
import SimpleBreadCrumb from 'src/components/widgets/BreadCrumb/SimpleBreadCrumb';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { pimApis } from 'src/api/pim';
import EditIcon from '@mui/icons-material/Edit';
import toast from 'react-hot-toast';
import { Box, TextField } from '@mui/material';
import { debounce } from 'lodash';
import CategoryDialog from 'src/components/CategoryDialog';
import FileUpload from 'src/components/FileUpload';
import CatagoryDrawer from './components/catagoryDrawer';
import RestartAltIcon from '@material-ui/icons/RestartAlt';


const useStyles = makeStyles<Theme>(() =>
  createStyles({
    activeButton: {
      background: 'rgba(7, 83, 0, 0.1)',
      color: 'rgba(29, 122, 21, 1)',
      width: '100px',
      '&:hover': {
        // Disable hover effect
        background: 'rgba(7, 83, 0, 0.1)',
        color: 'rgba(29, 122, 21, 1)',
      },
    },
    settingsTable: {
      "& .MuiTableRow-hover:hover": {
        backgroundColor: "transparent",
      },
    },

    inActiveButton: {
      background: 'rgba(255, 161, 161, 0.3)',
      color: 'red',
      width: '100px',
      '&:hover': {
        // Disable hover effect
        background: 'rgba(255, 161, 161, 0.3)',
        color: 'red',
      },
    },
    tabs: {
      '& .MuiTab-root': {
        backgroundColor: 'transparent',
        borderRadius: '4px',
        minWidth: '120px',
        minHeight: '30px',
      },
      '& .MuiTabs-indicator': {
        bottom: '6px',
      },
      '& .Mui-selected': {
        backgroundColor: '#231F20',
        color: '#fff',
      },
    },
  })
);
const Categories = () => {
  setTitle('ERP | Product Information Management');
  const location = useLocation();


  const classes = useStyles();
  const navigate = useNavigate();
  const saerchRef = useRef(null);
  const [categoriesData, setCategoriesData] = useState([]);
  const { catalogueId } = useParams<{ catalogueId: string }>();
  const catalogueName = localStorage.getItem('catalogueName');
  const [totalCount, setTotalCount] = useState<number>(0);
  const [activeTab, setActiveTab] = useState('all');
  const [page, setPage] = useState<any>(0);
  const [pageSize, setPageSize] = useState<any>(25);
  const [search, setSearch] = useState<string>('');
  const [selectedSort, setSelectedSort] = useState<any>({
    id: '',
    value: 'asc',
  });
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [addCategory, setAddCategory] = useState(false);
  const [uploadFile, setUploadFile] = useState(false);
  const [editCategory, setEditCategory] = useState(false);
  const [currentCategory, setCurrentCategory] = useState(null);

  const [cateInitialValues, setCateInitialValues] = useState<any>();
  const [currentRoute, setCurrentRoute] = useState<string>('');

  const fetchCategories = useCallback(async () => {
    try {
      const currentUrl = window.location.href;
      const id = currentUrl.split('/').pop();
      const productCatalogId = id;

      let isActiveParam;
      if (activeTab === 'active') {
        isActiveParam = true;
      } else if (activeTab === 'inactive') {
        isActiveParam = false;
      } else {
        isActiveParam = undefined;
      }

      const apiCall = currentUrl.includes('settings')
        ? pimApis.getAllCategories
        : pimApis.getCategories;

      // Fetch data
      const res = await apiCall(
        page,
        pageSize,
        search,
        selectedSort,
        isActiveParam,
        currentUrl.includes('settings') ? undefined : productCatalogId
      );

      // Update state with the response
      setCategoriesData(res?.data?.data);
      setTotalCount(res?.data?.totalRecords);
    } catch (error) {
      console.error('Error fetching catalog data:', error);
    }
  }, [page, pageSize, search, selectedSort, activeTab]);

  const handlePageSize = (_pageSize: any) => {
    setPageSize(_pageSize);
  };

  const handlePage = (_page: any) => {
    setPage(_page);
  };

  const handleOpenCategory = () => {
    setAddCategory(true);
  };

  const handleOpenEditCategory = () => {
    setAddCategory(true);
  };

  const handleCloseCategory = () => {
    setAddCategory(false);
    setEditCategory(false);
    setCurrentCategory(null);
  };

  const handleCloseUpload = () => {
    setUploadFile(false);
  };
  const handleOpenUpload = () => {
    setUploadFile(true);
  };

  const handleRowClick = (row) => {
    if (currentRoute.includes('catalogues')) {
      const { _id, name, productTemplateId } = row;
      localStorage.setItem('categoryName', name);
      navigate(`${_id}/${productTemplateId}`);
    }
  };

  const handleSubmit = async (values) => {
    const payload = {
      ...(currentCategory ? {} : { productCatalogueId: catalogueId }),
      ...values,
    };
    try {
      if (currentCategory) {
        await pimApis.updateCategory(currentCategory._id, payload);
        toast.success('Category updated successfully');
      } else {
        await pimApis.addCategory(payload);
        toast.success('Category added successfully');
      }
      fetchCategories(); // Refresh the list
      handleCloseCategory();
    } catch (error) {
      toast.error('Something went wrong');
      console.error('Error creating/updating category:', error);
    }
  };

  const { settings } = useSettings();

  const columns = [
    { id: 'name', label: 'Name', isSort: true },
    { id: 'description', label: 'Description', isSort: true },
    { id: 'numberOfProducts', label: 'No. Products', isSort: true },
    // numberOfProducts
    {
      id: 'isActive',
      label: 'Status',
      width: '15%',

      Cell: (rowStatus, row: any) => (
        <Button
          variant="contained"
          className={rowStatus ? classes.activeButton : classes.inActiveButton}
          onClick={async (e) => {
            e.stopPropagation();
            const { _id, isActive } = row;
            try {
              await pimApis.updateCategory(_id, { isActive: !rowStatus }); // Pass the inverse of the current status
              toast.success(
                `Category status updated to ${!rowStatus ? 'Active' : 'In active'
                }`
              );
              fetchCategories(); // Refresh the list after updating
            } catch (error) {
              toast.error('Error updating status');
              console.error('Error updating Category status:', error);
            }
          }}>
          {rowStatus ? 'Active' : 'In Active'}
        </Button>
      ),
      isSort: true,
    },
    {
      id: 'action',
      label: 'Action',
      width: '10%',

      Cell: (rowId, row) => (
        <EditIcon
          fontSize="small"
          onClick={(e) => {
            setCurrentCategory(row);
            setEditCategory(true);
            e.stopPropagation();
          }}
        />
      ),
    },
  ];
  const currentUrl = window.location.href;

  const BreadCrumbsData = {
    title: currentUrl.includes('settings') ? 'Settings' : 'Categories',
    links: currentUrl.includes('settings')
      ? []
      : [
        {
          name: 'Catalogues',
          to: '/pim/catalogues',
        },
        {
          name: catalogueName || 'Catalogue',
          to: `/pim/catalogues/${catalogueId}`,
        },
      ],
  };

  const debouncedSetSearchTerm = debounce((value) => {
    setSearch(value);
  }, 700); // Adjust the delay as needed

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    setActiveTab(newValue);
    setPage(0); // Reset to first page on tab change
  };

  const handleFileUpload = useCallback(
    async (file: any) => {
      const formData = new FormData();
      formData.append('file', selectedFile ?? file);

      try {
        await pimApis.uploadCategoryFile(catalogueId, formData);
        toast.success('File uploaded successfully');
        setSelectedFile(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        fetchCategories();
      } catch (error) {
        toast.error(error.response?.data?.message || 'File type not supported');
      }
    },
    [fetchCategories]
  );

  const handleSubmitUpload = async (file) => {
    setSelectedFile(file[0]);
    handleFileUpload(file[0]);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log('previous', file);
      setSelectedFile(file);
      handleFileUpload(file);
    }
  };

  const handleResetFilters = () => {
    if (saerchRef.current) {
      saerchRef.current.value = ""; // Clears the text in the input field
    }
    setSearch(''); // 
    // setFromDate(null); // 
    // setToDate(null); // 
    setActiveTab('all'); // 
    setPage(0); // 
  };


  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  useEffect(() => {
    const currentUrll = window.location.href; // or location.pathname for just the path
    setCurrentRoute(currentUrll);
    fetchCategories();
  }, [location]);

  return (
    <Container
      maxWidth={settings.compact ? 'xl' : false}
      sx={{
        py: 4,
      }}>
      <Grid container justifyContent="space-between" spacing={3}>
        <Grid
          container
          item
          alignItems="center"
          sx={{
            mb: 1,
          }}
          xs={12}>
          <Grid item xs={12} md={5}>
            <SimpleBreadCrumb data={BreadCrumbsData} />
          </Grid>
          <Grid item xs={12} md={7} display="flex" justifyContent="flex-end">
            {/* <Button
              variant="outlined"
              color="primary"
              onClick={() => fileInputRef.current?.click()} // Trigger file input click
            >
              Upload File
            </Button> */}
            {currentRoute.includes('settings') && (
              <Button
                variant="contained"
                color="secondary"
                onClick={handleResetFilters}
                title="Reset to defaults"
                sx={{
                  minWidth: '50px',
                  // p: 0,
                  ml: 1,
                }}>
                <RestartAltIcon />
              </Button>
            )}

            {currentRoute.includes('catalogues') && (
              <>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleOpenUpload}>
                  Upload File
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  title="Add Category"
                  sx={{ marginLeft: 2 }}
                  onClick={handleOpenCategory}>
                  Add Category
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleResetFilters}
                  title="Reset to defaults"
                  sx={{
                    minWidth: '50px',
                    p: 0,
                    ml: 1,
                  }}>
                  <RestartAltIcon />
                </Button>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                />
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Box
        mt={1}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <TextField
          variant="outlined"

          inputRef={saerchRef}
          placeholder="Search..."
          onChange={(e) => debouncedSetSearchTerm(e.target.value)}
          InputProps={{ style: { height: '40px', width: '240px' } }}
        />
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          className={classes.tabs}>
          <Tab label="All" value="all" />
          <Tab label="Active" value="active" />
          <Tab label="Inactive" value="inactive" />
        </Tabs>
      </Box>
      <Box className={currentRoute.includes('settings') ? classes.settingsTable : ''}>

        <CustomListView
          onRowClick={handleRowClick}
          columns={columns}
          data={categoriesData || []}
          page={page}
          pageSize={pageSize}
          setPageSize={handlePageSize}
          setPage={handlePage}
          count={totalCount}
          selectedSort={selectedSort}
          setSelectedSort={setSelectedSort}
        />
      </Box>
      {/* <CategoryDialog
        open={addCategory}
        onClose={handleCloseCategory}
        onSubmit={handleSubmit}
        initialValues={{ name: '', description: '' }}
        title="Add Category"
      /> */}

      <FileUpload
        open={uploadFile}
        onClose={handleCloseUpload}
        onSubmitt={handleSubmitUpload}
        // initialValues={cateInitialValues}
        title="Upload your Category"
      />

      <CatagoryDrawer
        open={addCategory || editCategory}
        onClose={handleCloseCategory}
        onSubmit={handleSubmit}
        initialValues={currentCategory}
        editCategory={editCategory}
        title={!editCategory ? 'Add Category' : 'Edit Category'}
      />
      {/* {editCategory && (
        <CategoryDialog
          open={editCategory}
          onClose={() => setEditCategory(false)}
          onSubmit={handleSubmit}
          initialValues={{
            name: currentCategory?.name,
            description: currentCategory?.description,
          }}
          title="Edit Category"
        />
      )} */}
    </Container >
  );
};

export default Categories;
